import React, { useState,useEffect } from "react";
import { Menu, Home, Building2, CreditCard, Wallet, Zap, ReceiptText,UngroupIcon, BarChart3, MessageSquare, Upload, Settings, ScrollText, User, LogOut,CoinsIcon } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import { useGetCompanyPropertyDetailsQuery } from "../lib/apiSlice/property/propertySlice.tsx";
import { serverUrl } from "../../../serverUrl.js";
import jwt_decode from "jwt-decode";

// import { useAuth } from "../context/AuthContext"; // Assuming you have auth context

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useGetCompanyPropertyDetailsQuery();
  const [foundLandlord, setFoundLandlord] = useState(null);

    const accessToken = localStorage.getItem("authTokens");
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;
    const config = {
      headers: { Authorization: `Bearer ${access}` },
    };
    const decodedToken = jwt_decode(accessToken);
    const userId = decodedToken.user_id;
    useEffect(() => {
      const fetchLandlord = async () => {
        try {
          const response = await serverUrl.get(`/landlord/landlord/?user_id=${userId}`, config);
          const landlordIds = response.data.results[0];
          setFoundLandlord(landlordIds);
        } catch (error) {
          console.error("Error fetching landlord:", error);
        }
      };
  
      fetchLandlord();
    }, []);

    const navItems = [
      { icon: <Home size={18} />, label: "Dashboard", path: "dashboard" },
      { icon: <Building2 size={18} />, label: "Properties", path: "properties" },
      { icon: <CreditCard size={18} />, label: "Subscription", path: "subscription" },
      { icon: <Wallet size={18} />, label: "Wallet", path: "wallet" },
      { icon: <Zap size={18} />, label: "Utilities", path: "utilities" },
      { icon: <ReceiptText size={18} />, label: "Expense", path: "expense" },
      // { icon: <UngroupIcon size={18} />, label: "Invoicing", path: "generate-invoicing" },
      ...(foundLandlord?.can_generate_invoice ? [
        { icon: <ScrollText size={18} />, label: "Approvals Payments", path: "payment-approvals" }
      ] : []),
       ...(foundLandlord?.payment_approvals ? [
        { icon: <CoinsIcon size={18} />, label: "Upload Payments", path: "payments-updates" }
      ] : []),
      //    ...(foundLandlord?.payment_approvals ? [
      //   { icon: <UngroupIcon size={18} />, label: "Invoicing", path: "all-invoices" }
      // ] : []),
      { icon: <BarChart3 size={18} />, label: "Reports", path: "reports" },
      { icon: <MessageSquare size={18} />, label: "Communicate", path: "messages" },
      { icon: <Upload size={18} />, label: "Bulk Uploads", path: "bulk" },
      ...(data?.results
        ? [{ icon: <Settings size={18} />, label: "Property Settings", path: "property-settings" }]
        : []),
      { icon: <User size={18} />, label: "Profile", path: "profile" },
    ];

  const handleLogout = () => {
    localStorage.removeItem("authTokens");
    navigate("/login");
  };

  return (
    <aside
      className={`bg-white border-r border-gray-200 text-black w-64 p-2 space-y-0 fixed inset-y-0 left-0 z-0 h-[100vh] transform ${isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out md:relative md:translate-x-0`}
      aria-label="Sidebar"
    >
      {/* Top - Mobile toggle */}
      <div className="md:hidden flex justify-between items-center mb-8">
        <h2 className="font-bold text-xl">Menu</h2>
        <button
          onClick={toggleSidebar}
          className="hover:bg-gray-200 p-1 rounded-md transition-colors"
          aria-label="Toggle sidebar"
        >
          <Menu className="text-black" />
        </button>
      </div>

      {/* Brand */}
      <div className="hidden md:block mt-3 mb-4">
        <h1
          className="font-fonarto font-bold text-blue-600 text-3xl text-center"
          style={{ fontFamily: "'Fonarto', sans-serif" }}
        >
          Kodi
        </h1>
      </div>

      {/* Navigation */}
      <nav className="space-y-0 py-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center space-x-3 p-2 py-2 mb-2 no-underline rounded-lg transition-colors ${isActive
                ? "bg-gray-200 text-dark font-medium"
                : "text-gray-800 hover:bg-gray-100"
              }`
            }
            end
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="right-0 bottom-2 left-0 absolute px-2">
        <button
          onClick={handleLogout}
          className="flex items-center space-x-3 hover:bg-gray-100 p-3 rounded-lg w-full text-gray-800 no-underline transition-colors"
        >
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
